import env from '@config/env';

const isAbsoluteHttpUrl = (value) => /^https?:\/\//i.test(String(value || '').trim());

const isRelativeApiPath = (value) => {
  const trimmed = String(value || '').trim();
  return Boolean(trimmed) && trimmed.startsWith('/') && !trimmed.startsWith('//');
};

/**
 * Builds the final request URL the same way Axios will, for logging/validation.
 */
export const resolveRequestUrl = (baseURL, url) => {
  const base = String(baseURL || '')
    .trim()
    .replace(/\/$/, '');
  const path = String(url || '').trim();

  if (!path) return base;
  if (isAbsoluteHttpUrl(path)) return path;
  if (!base) return path;
  if (path.startsWith('/')) return `${base}${path}`;
  return `${base}/${path}`;
};

export const assertValidRequestUrl = (config = {}) => {
  const baseURL = config.baseURL ?? env.API_BASE_URL;
  const url = config.url;
  const finalUrl = resolveRequestUrl(baseURL, url);

  if (!finalUrl || finalUrl === 'null' || finalUrl === 'undefined' || finalUrl === 'invalid') {
    const error = new Error(
      `[API] Refusing request with invalid URL. baseURL="${baseURL || ''}" url="${url ?? ''}"`,
    );
    error.code = 'ERR_INVALID_URL';
    error.config = config;
    throw error;
  }

  if (!isAbsoluteHttpUrl(finalUrl) && !isRelativeApiPath(finalUrl)) {
    const error = new Error(`[API] Refusing request with malformed URL: ${finalUrl}`);
    error.code = 'ERR_INVALID_URL';
    error.config = config;
    throw error;
  }

  if (env.IS_DEV) {
    console.debug('[API]', (config.method || 'get').toUpperCase(), finalUrl);
  }

  return finalUrl;
};

export default assertValidRequestUrl;
